<template>

  <!-- notif wizard -->
  <div>
    <v-snackbar
      v-model="notif.visible" :color="notif.kind" variant="flat" location="top right" rounded="pill"
    >
      {{ notif.message }}
      <template v-slot:actions>
        <v-btn
          class="text-none"
          variant="text"
          @click="notif.visible = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
  <ClearLayout v-if="layout.name == 'clear'" />
  <DefaultLayout v-if="layout.name == 'default'" />

  
</template>

<script setup>
import ClearLayout from '@/layout/ClearLayout.vue'
import DefaultLayout from '@/layout/DefaultLayout.vue'

import { layoutStore } from '@/stores/layout.js'
import { notifStore } from "@/stores/notif.js";

const layout = layoutStore()
const notif = notifStore()
</script>

<style>
/* @import '@/assets/css/base.css'; */
@import '@/assets/css/app.css';
</style>